import clsx from "clsx";
import { Fragment } from "react/jsx-runtime";
import StandardBreadcrumb from "../StandardBreadcrumb";

type Props = {
  title: string;
  children?: React.ReactNode;
  className?: string;
  breadcrumbItems?: {
    label: string;
    href?: string;
  }[];
};

const PageHeader = ({ title, children, className, breadcrumbItems }: Props) => {
  return (
    <div>
      {breadcrumbItems && <StandardBreadcrumb items={breadcrumbItems} />}
      <div
        className={clsx(
          "flex items-center justify-between pb-4 pt-2",
          className
        )}
      >
        <div>
          <div className="text-3xl font-semibold">{title}</div>
        </div>
        <div>{children}</div>
      </div>
    </div>
  );
};

export default PageHeader;
